import { useEffect, useState } from 'react';

import { AisPath, fetchAllAisPolygons } from 'dados/ais/aisPolygons';

export function useAisPolygons() {
  const [aisPolygons, setAisPolygons] = useState<AisPath[]>([]);

  useEffect(() => {
    let mounted = true;

    fetchAllAisPolygons().then(polygons => {
      if (mounted) setAisPolygons(polygons);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return { aisPolygons };
}
